import React from 'react';

export default function OurTeamHeader(props) {
    const {
        bookingLink,
        firstName,
        fullName,
        letters,
        mainDiscipline,
        type
    } = props;

    return (
        <article>
            <h2 className="minor-margin--bottom">
                {fullName} <span
                    className="text-small text-thin lowlight"
                    dangerouslySetInnerHTML={{__html: letters}}
                />
                <div
                    className="text-large text-thin"
                    dangerouslySetInnerHTML={{__html: mainDiscipline}}
                />
            </h2>

            <BookingLink firstName={firstName} bookingLink={bookingLink} type={type} />
        </article>
    )
};

const BookingLink = (props) => {
    const { bookingLink, firstName, type} = props;

    if (!bookingLink) {
        return null;
    }

    const linkText = type === 'instructor' ?
        'Book a class with ' + firstName :
        'Book with ' + firstName;

    return (
        <a
            className="button highlight decent-margin--bottom"
            target="_blank"
            href={bookingLink}
        >
            {linkText}
        </a>
    )
}
